import React from 'react';
import {classes, style, vars} from './ratio-maintainer.st.css';

interface RatioMaintainerProps extends React.HTMLAttributes<any> {
    widthHeightRatio: number | false;
}

/**
 * @deprecated use AspectRatioMaintainer instead
 */
export const RatioMaintainer = React.memo(React.forwardRef<HTMLDivElement, RatioMaintainerProps>((props, ref) => {

    const {
        widthHeightRatio,
        children,
        className,
        style: styleAttributes,
        ...htmlAttributes
    } = props;

    return (
        <div
            ref={ref}
            className={style(classes.root, {maintainRatio: !!widthHeightRatio}, props.className)}
            {...htmlAttributes}
            style={{
                [vars.ratio]: widthHeightRatio ? `${1 / widthHeightRatio * 100}%` : undefined,
                ...styleAttributes
            }}
        >
            {!!widthHeightRatio ? (
                <div className={style(classes.ratioPaddingContainer, classes.ratioMaintainerIgnore)}>
                    <div className={style(classes.ratioPadding)}/>
                </div>
            ) : null}
            {children}
        </div>
    )
}));

export const RatioMaintainerIgnoreClassName = classes.ratioMaintainerIgnore;
